import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import {
  FaArrowRight,
  FaCamera,
  FaCheckCircle,
  FaChevronLeft,
  FaChevronRight,
  FaExpand,
  FaImages,
  FaSearch,
  FaTimes,
} from 'react-icons/fa';

import '../styles/gallery-page.css';

import galleryHeroImage from '../pics/pressurepumpsite.jpg';

import calibrationOne from '../pics/caliberation.png';
import calibrationTwo from '../pics/caliberation 2.png';
import calibrationThree from '../pics/Calibration232.png';

import craneOne from '../pics/crane.png';
import craneTwo from '../pics/crane232.png';
import craneImage from '../pics/craneimage.png';

import liftingInspection from '../pics/liftinginspection.png';

import loadTestOne from '../pics/load test3.webp';
import loadTestTwo from '../pics/loadtest2.jpg';
import loadTestThree from '../pics/loadtesting232.png';

import pressurePumpOne from '../pics/pressure pump on site.webp';
import pressurePumpTwo from '../pics/pressure pump2.webp';
import pressurePumpThree from '../pics/pressurepumpsite.jpg';
import pressurePumpFour from '../pics/pressuretesting232.png';

import calibrationCheck from '../pics/workercheck.png';

import craneHookRigging from '../pics/Dofcanworkerslift.png';
import craneHookDetail from '../pics/dofequip.png';
import craneTruckLoadOut from '../pics/workersconnect.png';

import groundScanSurvey from '../pics/scrolworker.png';

import loadTestBagOne from '../pics/Dofbag.png';
import loadTestBagIndoor from '../pics/dofbag2.png';
import loadTestBatchLift from '../pics/batchlift.png';
import loadTestBatchLower from '../pics/batchlowlift.png';
import loadTestHighLift from '../pics/highlift.png';


const galleryImages = [
  {
    id: 1,
    src: calibrationOne,
    title: 'Calibration Activity',
    category: 'Calibration',
    description:
      'Calibration activity carried out as part of technical equipment support and field service operations.',
  },
  {
    id: 2,
    src: calibrationTwo,
    title: 'Calibration Team On Site',
    category: 'Calibration',
    description:
      'Technical personnel carrying out calibration-related work during field operations.',
  },
  {
    id: 3,
    src: calibrationThree,
    title: 'Calibration Equipment',
    category: 'Calibration',
    description:
      'Calibration equipment used during technical service activities.',
  },
  {
    id: 4,
    src: craneOne,
    title: 'Crane Support',
    category: 'Crane Operations',
    description:
      'Crane-related field activity supporting lifting operations.',
  },
  {
    id: 5,
    src: craneTwo,
    title: 'Crane Operations',
    category: 'Crane Operations',
    description:
      'Field view of crane operations and lifting equipment.',
  },
  {
    id: 6,
    src: craneImage,
    title: 'Crane Inspection Setup',
    category: 'Inspection',
    description:
      'Crane inspection setup prepared for technical assessment.',
  },
  {
    id: 7,
    src: liftingInspection,
    title: 'Lifting Inspection',
    category: 'Inspection',
    description:
      'Lifting equipment inspection activity conducted during field operations.',
  },
  {
    id: 8,
    src: loadTestOne,
    title: 'Load Testing Session',
    category: 'Load Testing',
    description:
      'Load testing activity showing equipment and personnel during a field session.',
  },
  {
    id: 9,
    src: loadTestTwo,
    title: 'Load Test Equipment',
    category: 'Load Testing',
    description:
      'Equipment used during load testing and technical field operations.',
  },
  {
    id: 10,
    src: loadTestThree,
    title: 'Load Test In Progress',
    category: 'Load Testing',
    description:
      'Load testing activity captured during practical field execution.',
  },
  {
    id: 11,
    src: pressurePumpOne,
    title: 'Pressure Pump On Site',
    category: 'Pressure Testing',
    description:
      'Pressure pump equipment positioned for field testing activities.',
  },
  {
    id: 12,
    src: pressurePumpTwo,
    title: 'Pressure Pump Support',
    category: 'Pressure Testing',
    description:
      'Pressure testing equipment and technical support during field operations.',
  },
  {
    id: 13,
    src: pressurePumpThree,
    title: 'Pressure Pump Overview',
    category: 'Pressure Testing',
    description:
      'Field overview of pressure pump equipment used during technical operations.',
  },
  {
    id: 14,
    src: pressurePumpFour,
    title: 'Pressure Testing Activity',
    category: 'Pressure Testing',
    description:
      'Pressure testing activity documented during field service delivery.',
  },
  {
    id: 15,
    src: calibrationCheck,
    title: 'Testing Instrument Check',
    category: 'Calibration',
    description:
      'Technician connecting a portable testing instrument to a crane hook block during field calibration work.',
  },
  {
    id: 16,
    src: craneHookRigging,
    title: 'Hook & Rigging Connection',
    category: 'Crane Operations',
    description:
      'Personnel securing rigging chains to a crane hook block (SWL 10T) ahead of a lifting operation.',
  },
  {
    id: 17,
    src: craneHookDetail,
    title: 'Crane Hook Block Detail',
    category: 'Crane Operations',
    description:
      'Close-up view of a crane hook block (SWL 10T) used during rigging and lifting field operations.',
  },
  {
    id: 18,
    src: craneTruckLoadOut,
    title: 'Crane Load-Out To Truck',
    category: 'Crane Operations',
    description:
      'Field team guiding a crane-lifted load onto a flatbed truck during a load-out operation.',
  },
  {
    id: 19,
    src: groundScanSurvey,
    title: 'Ground Scanning Survey',
    category: 'Inspection',
    description:
      'Technician operating a wheeled ground-scanning survey unit as part of a site inspection activity.',
  },
  {
    id: 20,
    src: loadTestBagOne,
    title: 'Proof Load Bag Lift',
    category: 'Load Testing',
    description:
      'Water-filled proof load test bag suspended from a crane hook during a load testing operation aboard a vessel.',
  },
  {
    id: 21,
    src: loadTestBagIndoor,
    title: 'Proof Load Bag (SWL 25T)',
    category: 'Load Testing',
    description:
      'Proof load test bag rated SWL 25T suspended for load testing in an indoor workshop setting.',
  },
  {
    id: 22,
    src: loadTestHighLift,
    title: 'High-Angle Lift View',
    category: 'Load Testing',
    description:
      'Elevated view of a field team and crane truck positioning a proof load test bag during a lifting operation.',
  },
  {
    id: 23,
    src: loadTestBatchLower,
    title: 'Guiding The Test Load',
    category: 'Load Testing',
    description:
      'Field crew guiding a proof load test bag into position beneath a crane hook during load testing.',
  },
  {
    id: 24,
    src: loadTestBatchLift,
    title: 'Lifting Safety In Action',
    category: 'Load Testing',
    description:
      'Field team coordinating a proof load test bag lift, captured beside on-site "Lifting Safety, Our Priority" signage.',
  },
];


const categories = [
  'All',
  'Calibration',
  'Crane Operations',
  'Inspection',
  'Load Testing',
  'Pressure Testing',
];


export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);


  const filteredImages = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();

    return galleryImages.filter((image) => {
      const matchesCategory =
        activeCategory === 'All' ||
        image.category === activeCategory;

      const matchesSearch =
        !search ||
        image.title.toLowerCase().includes(search) ||
        image.category.toLowerCase().includes(search) ||
        image.description.toLowerCase().includes(search);

      return matchesCategory && matchesSearch;
    });
  }, [activeCategory, searchTerm]);


  const categoryCount = categories.length - 1;

  const featuredImage = galleryImages[galleryImages.length - 1];
  const featuredIndex = galleryImages.length - 1;


  const openImage = (image) => {
    setSelectedImage(image);
  };


  const closeImage = () => {
    setSelectedImage(null);
  };


  const showPrevious = () => {
    if (!selectedImage) return;

    const currentIndex = filteredImages.findIndex(
      (image) => image.id === selectedImage.id
    );

    const previousIndex =
      currentIndex <= 0
        ? filteredImages.length - 1
        : currentIndex - 1;

    setSelectedImage(filteredImages[previousIndex]);
  };


  const showNext = () => {
    if (!selectedImage) return;

    const currentIndex = filteredImages.findIndex(
      (image) => image.id === selectedImage.id
    );

    const nextIndex =
      currentIndex >= filteredImages.length - 1
        ? 0
        : currentIndex + 1;

    setSelectedImage(filteredImages[nextIndex]);
  };


  return (
    <div className="gallery-page">
      <SEO
        title="Gallery"
        description="Browse photos of Dofcan Oilserve's field operations, including crane operations, load testing, pressure testing, calibration and lifting equipment inspection."
        path="/gallery"
      />

      {/* =====================================================
          HERO / ARCHIVE HEADER
      ===================================================== */}

      <section className="gallery-hero">
        <div className="gallery-hero-pattern"></div>

        <div className="gallery-container">

          <div className="gallery-breadcrumb">
            <Link to="/">Dofcan Oilserve Limited</Link>
            <FaArrowRight />
            <strong>Gallery</strong>

            <span className="gallery-status">
              <span></span>
              Field Media Archive
            </span>
          </div>


          <div className="gallery-hero-grid">

            <div className="gallery-hero-content">

              <div className="gallery-eyebrow">
                <span></span>
                Field Operations • Equipment • Technical Work
              </div>

              <h1>
                Our Work,
                <br />
                In Focus.
              </h1>

              <p>
                Explore a visual collection of Dofcan Oilserve
                activities covering calibration, crane operations,
                lifting inspection, load testing, and pressure
                testing.
              </p>

              <div className="gallery-hero-buttons">
                <button
                  type="button"
                  className="gallery-btn-primary"
                  onClick={() =>
                    document
                      .getElementById('gallery-repository')
                      ?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                      })
                  }
                >
                  Explore Gallery
                  <FaArrowRight />
                </button>

                <button
                  type="button"
                  className="gallery-btn-secondary"
                  onClick={() => {
                    setActiveCategory('All');
                    setSearchTerm('');
                    document
                      .getElementById('gallery-repository')
                      ?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                      });
                  }}
                >
                  View All Images
                  <FaImages />
                </button>
              </div>

            </div>


            <div className="gallery-hero-visual">

              <img
                src={galleryHeroImage}
                alt="Dofcan Oilserve pressure testing field activity"
              />

              <div className="gallery-hero-overlay"></div>

              <div className="gallery-hero-caption">
                <div className="gallery-caption-icon">
                  <FaCamera />
                </div>

                <div>
                  <span>DOFCAN FIELD ARCHIVE</span>
                  <strong>
                    Practical Work • Technical Operations
                  </strong>
                </div>
              </div>

            </div>

          </div>


          {/* =================================================
              ARCHIVE METRICS
          ================================================= */}

          <div className="gallery-metrics">

            <div className="gallery-metric">
              <div className="gallery-metric-top">
                <span>Visual Records</span>
                <FaImages />
              </div>

              <strong>{galleryImages.length}</strong>

              <p>
                Images in the current gallery
              </p>
            </div>


            <div className="gallery-metric">
              <div className="gallery-metric-top">
                <span>Categories</span>
                <FaCamera />
              </div>

              <strong>{categoryCount}</strong>

              <p>
                Field activity categories
              </p>
            </div>


            <div className="gallery-metric">
              <div className="gallery-metric-top">
                <span>Equipment</span>
                <FaCheckCircle />
              </div>

              <strong>{String(categoryCount).padStart(2, '0')}</strong>

              <p>
                Major activity areas represented
              </p>
            </div>


            <div className="gallery-metric">
              <div className="gallery-metric-top">
                <span>Archive Status</span>
                <span className="gallery-live-dot"></span>
              </div>

              <strong>Live</strong>

              <p>
                Current visual repository
              </p>
            </div>

          </div>


          {/* =================================================
              DIRECTORY NAV
          ================================================= */}

          <div className="gallery-directory">

            <span>Gallery Directory:</span>

            {categories.map((category) => (
              <button
                key={category}
                type="button"
                className={
                  activeCategory === category
                    ? 'active'
                    : ''
                }
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}

          </div>

        </div>
      </section>


      {/* =====================================================
          GALLERY REPOSITORY
      ===================================================== */}

      <section
        id="gallery-repository"
        className="gallery-repository"
      >

        <div className="gallery-container">

          {/* HEADER */}

          <div className="gallery-section-heading">

            <div>

              <div className="gallery-section-label">
                <span></span>
                Visual Field Repository
              </div>

              <h2>
                Technical Work &
                <br />
                Field Operations
              </h2>

            </div>

            <p>
              Browse the available visual records from Dofcan
              Oilserve activities. Use the category filters or
              search field to quickly locate a specific type of
              work.
            </p>

          </div>


          {/* =================================================
              CONTROLS
          ================================================= */}

          <div className="gallery-controls">

            <div className="gallery-filter-tabs">

              {categories.map((category) => (
                <button
                  key={category}
                  type="button"
                  className={
                    activeCategory === category
                      ? 'active'
                      : ''
                  }
                  onClick={() =>
                    setActiveCategory(category)
                  }
                >
                  {category}
                </button>
              ))}

            </div>


            <div className="gallery-result-count">
              <FaImages />

              <span>
                {filteredImages.length}{' '}
                {filteredImages.length === 1
                  ? 'Record'
                  : 'Records'}
              </span>
            </div>

          </div>


          {/* SEARCH */}

          <div className="gallery-search-row">

            <div className="gallery-search-box">

              <FaSearch />

              <input
                type="text"
                value={searchTerm}
                onChange={(e) =>
                  setSearchTerm(e.target.value)
                }
                placeholder="Search gallery by activity, equipment, or category..."
              />

              {searchTerm && (
                <button
                  type="button"
                  className="gallery-search-clear"
                  onClick={() => setSearchTerm('')}
                  aria-label="Clear search"
                >
                  <FaTimes />
                </button>
              )}

            </div>

            <div className="gallery-search-status">
              Showing{' '}
              <strong>{filteredImages.length}</strong>{' '}
              of{' '}
              <strong>{galleryImages.length}</strong>{' '}
              images
            </div>

          </div>


          {/* =================================================
              FEATURED IMAGE
          ================================================= */}

          {activeCategory === 'All' &&
            !searchTerm &&
            galleryImages.length > 0 && (
              <div className="gallery-featured">

                <div className="gallery-featured-image">

                  <img
                    src={featuredImage.src}
                    alt={featuredImage.title}
                  />

                  <div className="gallery-featured-overlay"></div>

                  <span className="gallery-featured-tag">
                    FEATURED FIELD ACTIVITY
                  </span>

                  <button
                    type="button"
                    className="gallery-featured-expand"
                    onClick={() =>
                      openImage(featuredImage)
                    }
                    aria-label="View featured image"
                  >
                    <FaExpand />
                  </button>

                  <div className="gallery-featured-caption">

                    <span>
                      {featuredImage.category}
                    </span>

                    <h3>
                      {featuredImage.title}
                    </h3>

                    <p>
                      {featuredImage.description}
                    </p>

                  </div>

                </div>


                <div className="gallery-featured-info">

                  <div className="gallery-featured-info-top">
                    <span>FIELD RECORD</span>
                    <strong>{featuredIndex + 1} / {galleryImages.length}</strong>
                  </div>

                  <h3>
                    {featuredImage.category}
                    <br />
                    Field Activity
                  </h3>

                  <p>
                    A visual record of {featuredImage.category.toLowerCase()}
                    {' '}activity within the current Dofcan Oilserve
                    gallery.
                  </p>

                  <div className="gallery-featured-details">

                    <div>
                      <span>Category</span>
                      <strong>
                        {featuredImage.category}
                      </strong>
                    </div>

                    <div>
                      <span>Archive</span>
                      <strong>
                        Field Operations
                      </strong>
                    </div>

                  </div>

                  <button
                    type="button"
                    onClick={() =>
                      openImage(featuredImage)
                    }
                    className="gallery-featured-button"
                  >
                    Inspect Image
                    <FaArrowRight />
                  </button>

                </div>

              </div>
            )}


          {/* =================================================
              IMAGE GRID
          ================================================= */}

          {filteredImages.length > 0 ? (

            <div className="gallery-grid">

              {filteredImages.map((image, index) => (

                <article
                  key={image.id}
                  className="gallery-card"
                >

                  <div className="gallery-card-image">

                    <img
                      src={image.src}
                      alt={image.title}
                      loading={
                        index < 6
                          ? 'eager'
                          : 'lazy'
                      }
                    />

                    <div className="gallery-card-overlay"></div>

                    <span className="gallery-card-number">
                      {String(image.id).padStart(2, '0')}
                    </span>

                    <span className="gallery-card-category">
                      {image.category}
                    </span>

                    <button
                      type="button"
                      className="gallery-card-expand"
                      onClick={() =>
                        openImage(image)
                      }
                      aria-label={`View ${image.title}`}
                    >
                      <FaExpand />
                    </button>

                  </div>


                  <div className="gallery-card-body">

                    <div className="gallery-card-meta">
                      <span>
                        FIELD RECORD
                      </span>

                      <span>
                        #{String(image.id).padStart(2, '0')}
                      </span>
                    </div>

                    <h3>
                      {image.title}
                    </h3>

                    <p>
                      {image.description}
                    </p>

                    <button
                      type="button"
                      onClick={() =>
                        openImage(image)
                      }
                      className="gallery-card-button"
                    >
                      View Image
                      <FaArrowRight />
                    </button>

                  </div>

                </article>

              ))}

            </div>

          ) : (

            <div className="gallery-empty">

              <FaSearch />

              <h3>
                No Gallery Records Found
              </h3>

              <p>
                No images match the selected category or search
                term.
              </p>

              <button
                type="button"
                onClick={() => {
                  setActiveCategory('All');
                  setSearchTerm('');
                }}
              >
                Reset Gallery
              </button>

            </div>

          )}

        </div>

      </section>


      {/* =====================================================
          GALLERY INFORMATION BANNER
      ===================================================== */}

      <section className="gallery-information" data-reveal>

        <div className="gallery-container">

          <div className="gallery-information-box">

            <div className="gallery-information-content">

              <div className="gallery-information-label">
                <FaCheckCircle />
                DOFCAN VISUAL ARCHIVE
              </div>

              <h2>
                Practical Work.
                <br />
                Clearly Documented.
              </h2>

              <p>
                This gallery provides a visual record of selected
                training, inspection, testing, calibration, and
                field-support activities represented within the
                current website media collection.
              </p>

            </div>


            <div className="gallery-information-stats">

              <div>
                <strong>
                  {galleryImages.length}
                </strong>

                <span>
                  Visual Records
                </span>
              </div>

              <div>
                <strong>
                  {categoryCount}
                </strong>

                <span>
                  Activity Categories
                </span>
              </div>

              <div>
                <strong>
                  01
                </strong>

                <span>
                  Digital Gallery
                </span>
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <section className="gallery-final-cta" data-reveal>

        <div className="gallery-container">

          <div className="gallery-final-grid">

            <div>

              <span>
                DOFCAN OILSERVE LIMITED
              </span>

              <h2>
                Explore Our Services
                <br />
                Beyond The Gallery.
              </h2>

              <p>
                Learn more about our training, inspection,
                certification, and technical service activities.
              </p>

            </div>


            <div className="gallery-final-actions">

              <Link to="/services">
                View Services
                <FaArrowRight />
              </Link>

              <Link to="/contact">
                Contact Our Team
                <FaArrowRight />
              </Link>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          IMAGE LIGHTBOX
      ===================================================== */}

      {selectedImage && (

        <div
          className="gallery-lightbox"
          onClick={closeImage}
          role="dialog"
          aria-modal="true"
          aria-label="Gallery image viewer"
        >

          <button
            type="button"
            className="gallery-lightbox-close"
            onClick={closeImage}
            aria-label="Close image viewer"
          >
            <FaTimes />
          </button>


          <button
            type="button"
            className="gallery-lightbox-prev"
            onClick={(e) => {
              e.stopPropagation();
              showPrevious();
            }}
            aria-label="Previous image"
          >
            <FaChevronLeft />
          </button>


          <div
            className="gallery-lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >

            <img
              src={selectedImage.src}
              alt={selectedImage.title}
            />

            <div className="gallery-lightbox-info">

              <div>
                <span>
                  {selectedImage.category}
                </span>

                <h3>
                  {selectedImage.title}
                </h3>

                <p>
                  {selectedImage.description}
                </p>
              </div>

              <strong>
                #{String(selectedImage.id).padStart(2, '0')}
              </strong>

            </div>

          </div>


          <button
            type="button"
            className="gallery-lightbox-next"
            onClick={(e) => {
              e.stopPropagation();
              showNext();
            }}
            aria-label="Next image"
          >
            <FaChevronRight />
          </button>

        </div>

      )}

    </div>
  );
}